<template>
    <div>

      <b-modal id="modalTraceablePQComponent"
        :title="`Trazabilidad de fg ${actionProcessing}`" scrollable centered
        no-close-on-backdrop no-close-on-esc no-enforce-focus no-fade header-close-content="">

          <form :data-vv-scope="'traceable_form'">
              <!-- Contenido -->
              <formTraceable :label_comment="'Motivo por el cual realiza la acción'"/>
          </form>

          <!-- Footer -->
          <template #modal-footer>

          <b-button variant="primary" @click="onHandleOk()" :disabled="validateForm()">
            <span v-if="!loading">Confirmar</span>
            <span v-else>Por favor, espera...</span>
          </b-button>

          <b-button variant="light" @click="onHandleCancel()" :disabled="loading || loadingCancelProcess">
            <span v-if="!loadingCancelProcess">Cancelar</span>
            <span v-else>Cancelando...</span>
          </b-button>

        </template>

      </b-modal>

    </div>
  </template>

  <script>

  // Generales
  import { mapState, mapMutations } from 'vuex';
  import FormTraceable from '@/views/history/assignPQ/fragments/FormTraceable.vue'

  export default {
    name: 'ModalTraceablePQComponent',
    props: {
      confirmAssigned: {
        type: Function,
        default: () => { }
      },
      loading: {
        type: Boolean,
        default: false
      }
    },
    components: {
      formTraceable: FormTraceable
    },
    data: function () {
      return {
        traceableText: ''
      };
    },
    computed: {
      // Estados del modulo: dashboard
      ...mapState('asignacionproductos', ['loadingCancelProcess']),
      // Estados del modulo: trazabilidad de asignaciones y usos
      ...mapState('assignPQTraceable', ['traceable','actionToTraceablePQ']),
      actionProcessing() {
        if (this.actionToTraceablePQ.action === 'ASSIGNMENT') return 'asignación';
        if (this.actionToTraceablePQ.action === 'USE') return 'uso';

        return "información";
      },
      getTextInput() {
        return "Motivo por el cual realiza la acción";
      }
    },
    methods: {
      // Mutaciones del modulo: dashboard
      ...mapMutations('asignacionproductos', ['setLoadingCancelProcess']),
      ...mapMutations('assignPQTraceable', ['resetTraceable']),
      validateForm() {
          let isTypeValid = false;
          if(this.traceable.type === null || this.traceable.type === '') isTypeValid = true;
          else if(((this.traceable.type === 'TICKETS' || this.traceable.type === 'OTHER') && (this.traceable.comments === '' || this.traceable.comments === null )))isTypeValid = true;
          return this.loading || this.loadingCancelProcess || isTypeValid
      },
      onHandleOk() {
          this.$validator.validateAll('traceable_form')
          .then(async (result) => {
              if (result) {
                  this.confirmAssigned(true, this.actionToTraceablePQ)
                  .then(() => {
                      this.resetTraceable();
                  });
              }
          });
      },
      onHandleCancel() {
        this.setLoadingCancelProcess(true);
        this.resetTraceable();
        this.confirmAssigned(false, this.actionToTraceablePQ);
      }
    }
  };
  </script>
